<nz-empty
  class="ui-empty"
  [nzNotFoundImage]="image()"
  [nzNotFoundContent]="content()"
  [nzNotFoundFooter]="footer()"
></nz-empty>
